module.exports = __webpack_public_path__ + "img/sticker-good.d0d46ee6.svg";